<template>
  <div class="h-sm flex w-full justify-end gap-3 pr-[2px]">
    <slot />
  </div>
</template>
